import { Component } from '@angular/core';

import { MouseMode } from '../../models/mouse-mode';
import { MouseModeService } from '../../services/mouse-state.service';

/** Component for showing metadata about the plot data */
@Component({
    selector: 'sci-select-tools',
    template: `
        <button mat-icon-button matTooltip="Select Annotations" (click)="selectTool()">
            <mat-icon svgIcon="pointer"></mat-icon>
        </button>
    `,
    styleUrls: [ './annotations.component.scss' ]
})
export class SelectToolsComponent  {

    constructor( private _mouseModeService: MouseModeService ) {}

    selectTool() {
        this._mouseModeService.setMouseMode( MouseMode.NONE );
    }
}
